export const INITIALIZING_APPLICATION = 'INITIALIZING_APPLICATION'
export const READY_FOR_RENDER = 'READY_FOR_RENDER'
